(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-result/assets/react/components/result-interval.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-result/assets/react/components/result-interval.js');

'use strict';

const {
  useAtomValue
} = jotai;
const {
  selectedSpanResultsAtom,
  overlayResultAtom
} = svs.lyckoplatsen.components.shared_result.jotai.atoms;
const {
  MapInterval,
  Overlay,
  WinAmountInterval
} = svs.lyckoplatsen.components.page_result.react.components;
const ResultInterval = () => {
  const spanResults = useAtomValue(selectedSpanResultsAtom);
  const result = useAtomValue(overlayResultAtom);
  const hasSelectedResult = Boolean(result);
  return React.createElement("div", {
    className: "lp-page-result"
  }, React.createElement(MapInterval, {
    results: spanResults.results
  }), React.createElement(WinAmountInterval, null), React.createElement("div", {
    className: "u-text-center f-600 f-bold margin-2 margin-top-1"
  }, React.createElement("p", null, "Klicka p\xE5 en av lyckoplatserna som vunnit toppvinsten - f\xF6r att se vinstcirklarna och mer information om dragningen.")), hasSelectedResult && React.createElement(Overlay, null));
};
Object.assign(svs.lyckoplatsen.components.page_result.react.components, {
  ResultInterval
});

 })(window);